const validateString = (providedEmail) =>
  String(providedEmail)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

export default (eAddress) => {
  let isValid = true;
  if (typeof eAddress === 'object') {
    eAddress.forEach((email) => {
      if (validateString(email)) {
        isValid = true;
      } else {
        isValid = false;
      }
    });
  } else {
    isValid = validateString(eAddress);
  }

  return isValid;
};
